<div class="wrapping">
  <table>
    @for (field of config.fields; track field) {
      <tr>
        <td>
          <span class="param">{{ config.translateKey + field.param| translate }} : </span>
          <span class="detail">
            @if ((field.param !== 'employee') && (field.type !== 'DATETIME')) {
              {{ detail[field.param] }}
            } @else if (field.param === 'employee') {
              {{ detail[field.param] | firstLastName }}
            } @else if (field.type === 'DATETIME') {
              {{ detail[field.param] | dateExtra }}
            }
          </span>
        </td>
      </tr>
    }

    <tr>
      <td class="delete">
        <span class="param">Deleted : </span>
        <span class="detail">{{ detail.deleted }}</span>
      </td>
    </tr>

    @if (detail.deleted) {
      <tr>
        <td>
          <span class="param">Deleted_at : </span>
          <span class="detail">{{ detail.deleteAt }}</span>
        </td>
      </tr>
      <tr>
        <td>
          <span class="param">Deleted_by : </span>
          <span class="detail">{{ detail.deletedBy }}</span>
        </td>
      </tr>
    }
  </table>
</div>
